export default "<p>get-data works!</p>\n"